


<template>
    <el-main>
        <div style="margin-bottom: 15px; display: flex;flex-flow: row;justify-content:flex-start">
            <el-input placeholder="请输入仪器组名" v-model="toolName" style="width: 300px" >
            </el-input>
            <el-button type="primary" plain @click="sele" style="margin-left: 10px">搜索</el-button>
            <el-button type="primary" plain @click="refresh" style="margin-left: 10px">刷新</el-button>
            <el-button type="primary" plain @click="handleAdd" style="margin-left: 10px">新建仪器组</el-button>
        </div>

        <div>
            <el-table :data="tool" border style="width: 180%">
                <el-table-column prop="toolId" label="仪器组号" ></el-table-column>
                <!--                <el-table-column prop="createBy" label="创建人"></el-table-column>-->
                <el-table-column prop="toolName" label="仪器组名" ></el-table-column>
                <el-table-column prop="createDate" label="创建时间" >
                    <template v-slot="scope">
                        <!--   显示时间格式为年月日时分秒  <span>{{formatDate(scope.row.createDate,"yyyy-MM-dd hh:mm:ss")}}</span>-->

                        <span>{{formatDate(scope.row.createDate,"yyyy-MM-dd")}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template v-slot="scope">
                        <el-button  type="primary" plain size="small" @click="check(scope.row.toolId)">查看仪器表</el-button>
                        <el-button  type="primary" plain  size="small" @click="toupdate(scope.row)">编辑</el-button>
                        <el-button  type="danger"  plain  size="small" @click="dele(scope.row.toolId)">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>


        <el-dialog v-model="formVisible" title="添加仪器组" :lock-scroll="false" width="45%" draggable>
<!--            <el-dialog title="添加仪器组" :visible.sync="formVisible">-->

            <el-form ref="form" :model="form" status-icon label-width="160px" :rules="rule" >

                <el-form-item label="仪器组名" prop="toolName">
                    <!--                    <el-input  v-model="form.toolName"  @change="nameCheck1"></el-input>-->
                    <el-input  v-model="form.toolName"  ></el-input>
                </el-form-item>

                <el-form-item label="仪器组号" prop="toolId">
                    <!--                    <el-input  v-model="form.toolId"  @change="nameCheck2"></el-input>-->
                    <el-input  v-model="form.toolId" ></el-input>
                </el-form-item>
            </el-form>

            <template #footer>
                      <span class="dialog-footer" >
                        <el-button style="margin-top: -40px" @click="formVisible = false">关闭</el-button>
                        <el-button style="margin-top: -40px"  type="primary" @click="save1">确定</el-button>
                      </span>
            </template>
        </el-dialog>

        <!-- ref和：ref有区别
            :lock-scroll="false"是固定背景不动
            draggable实现表单随便拖动
            status-icon是网络状态图标
                  -->
        <el-dialog v-model="form2Visible" title="编辑仪器组" :lock-scroll="false" width="45%" draggable>
            <el-form ref="form2" :model="form2"  :rules="rule" status-icon label-width="160px">

                <el-form-item label="仪器组名" prop="toolName">
                    <!--                    <el-input  v-model="form2.toolName"  @change="nameCheck1"></el-input>-->
                    <el-input  v-model="form2.toolName" ></el-input>
                </el-form-item>
                <el-form-item label="仪器组号" prop="toolId">
                    <!--                    <el-input  v-model="form2.toolId"  @change="nameCheck2"></el-input>-->
                    <el-input  v-model="form2.toolId"  readonly></el-input>
                </el-form-item>
            </el-form>

            <template #footer>
                      <span class="dialog-footer" >
                        <el-button style="margin-top: -40px" @click="form2Visible = false">关闭</el-button>
                        <el-button style="margin-top: -40px"  type="primary" @click="save2">确定</el-button>
                      </span>
            </template>

        </el-dialog>
    </el-main>
</template>


<script>
    import request from "../../util/request";

    export default {
        // eslint-disable-next-line vue/multi-word-component-names
        name: 'Toolbox.vue',
        data(){
            return{
                toolName:'',
                toolId:'',
                tool:[],
                ticket:[],
                reData:{},
                formVisible:false,
                form:{
                    toolName:'',
                    toolId:'',
                },
                form2Visible:false,
                form2:{
                    toolName:'',
                    toolId:'',
                },
                currentPage: 1,
                total:0,
                pageSize:5,
                pageSizes:[5, 10, 15, 20,25,30],
                options: [],
                value1: [],
                value2:[],
                rule:{
                    toolName:[
                        { required:true,message:'请输入仪器组名',trigger:'blur'},
                    ],
                    toolId:[
                        { required:true,message:'请输入仪器组号',trigger:'blur'},
                    ],
                }
            }
        },
        created() {
            this.load();
        },
        mounted(){
            console.log(this.$refs)
        },
        methods:{
            //时间格式
            formatDate(value, fmt) {
                if (value == null || value == '') {
                    return ""
                }
                let getDate = new Date(value);
                let o = {
                    'M+': getDate.getMonth() + 1,
                    'd+': getDate.getDate(),
                    'h+': getDate.getHours(),
                    'm+': getDate.getMinutes(),
                    's+': getDate.getSeconds(),
                    'q+': Math.floor((getDate.getMonth() + 3) / 3),
                    'S': getDate.getMilliseconds()
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
                }
                for (let k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) {
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                    }
                }
                return fmt;
            },
            load() {
                console.log("234567890")
                // var _this = this;
                request.get( '/tool/queryList' ).then( res => {
                    this.ticket = res
                    console.log(this.ticket)
                    this.total=res.length;
                    this.getPageInfo();
                } )
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.currentPage = val
                this.getPageInfo()
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pageSize = val
                this.getPageInfo()
            },
            // 获取当前页的数据信息
            getPageInfo() {
                //清空pageTicket中的数据
                this.tool = [];
                // 获取当前页的数据
                for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
                    //把遍历的数据添加到pageTicket里面
                    this.tool.push(this.ticket[i]);
                    //判断是否达到一页的要求
                    if (this.tool.length === this.pageSize) break;
                }
            },
            //搜索
            sele(){
                if(this.toolName==null || this.toolName == "")
                {
                    this.$message( {
                        message: '请输入仪器组名',
                        type: 'warning'
                    } );
                    return ;
                }
                request.post( '/tool/select', this.toolName ).then( res => {
                    console.log(res)
                    this.ticket = res
                    this.total=res.length;
                    this.getPageInfo();
                    console.log( res )
                    for (let i = 0; i < this.tool.length; i++) {
                        console.log("tool.name"+this.tool[i].toolName)
                    }
                    this.$message({
                        message: '查询成功',
                        type: 'success'
                    });
                })
            },
            //删除操作
            dele (id) {
                console.log("222")
                console.log(id)

                // eslint-disable-next-line no-unused-vars
                this.$confirm('您确认删除吗','确认删除',{type:"warning"}).then(response =>{
                    request.post( '/tool/delete',id).then( res => {
                        console.log("33333")
                        console.log( res )
                        console.log(res.length)
                        console.log(this.total+"0000")
                        if(res.length==this.total)
                        {
                            this.$message.error( '删除失败，仪器表还有数据' )
                        }
                        else{
                            this.$message.success( '删除成功' )
                        }
                        //在第二页删除完数据，第一页还有数据，能够正确展示出第一页的数据
                        this.currentPage=1;
                        this.load()
                    } )
                }).catch(()=>{})
            },
            //查看仪器表
            check(toolid) {
                console.log("111222333")
                console.log(toolid)
                //带参数路径的路由跳转，点击查看仪器表跳转仪器表的页面
                // this.$router.push({name:'Instrument' ,params:{id:toolid}})
                this.$router.push({path:'instrument', query:{id:toolid}})
            },

            //修改操作
            toupdate(row) {
                console.log( "qqqq" )
                this.form2 = {}
                this.form2Visible = true //打开弹窗
                console.log( "ttt" )
                this.$nextTick(() => {
                    console.log("tttt");
                    //表单验证清除，第一遍点显示出不为空，第二遍清除第一遍的判断，又变为初始化的样子
                    setTimeout(() => {
                        this.$refs.form2.clearValidate();
                    }, 0);
                });
                this.form2 = JSON.parse( JSON.stringify( row ) );//这种拷贝方式，form2改变，row不会改变，点击确定保存后才会同步更改
                this.reData = JSON.parse( JSON.stringify( row ) )
            },
            save2(){
                console.log("rrrr")
                let b  =false ;
                for(let i=0;i<this.ticket.length;i++) {
                    //修改后的组号不能和表格其他一样，但是可以和当前的一样
                    if ( this.form2.toolId == this.ticket[i].toolId && this.form2.toolId !=this.reData.toolId) {
                        this.$message({
                            message: '仪器组号不能重复',
                            type: 'warning'
                        });
                        b=true;
                        break;
                    }
                    if (this.form2.toolName === this.ticket[i].toolName  && this.form2.toolName !==this.reData.toolName) {
                        this.$message( {
                            message: '仪器组名不能重复',
                            type: 'warning'
                        } );
                        b=true
                        break;
                    }
                }
                if(b){
                    return false;
                }
                //判断表单输入框不能为空
                if(this.form2.toolName==null ||this.form2.toolName==''||this.form2.toolName==undefined)
                {
                    this.$message({
                        message: '仪器组名不为空',
                        type: 'warning'
                    });
                    return false;
                }
                console.log("-----uu")
                if(this.form2.toolId==null ||this.form2.toolId==''||this.form2.toolId==undefined)
                {
                    this.$message({
                        message: '仪器组号不为空',
                        type: 'warning'
                    });
                    return false;
                }
                console.log("-----kk")
                // eslint-disable-next-line no-unused-vars
                request.post( '/tool/update',this.form2 ).then( res => {
                    console.log( this.form2 );
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                    this.load()
                    this.form2Visible=false //关闭弹窗
                })
            },

            //新建仪器组
            handleAdd(){
                this.form = {};
                this.formVisible = true; //打开弹窗
                console.log("mmmmm");
                this.$nextTick(() => {
                    console.log("tttt");
                    setTimeout(() => {
                        this.$refs.form.clearValidate();
                    }, 0);
                });
                console.log("xxxxx");

            },
            save1(){
                console.log("1111")
                console.log(this.ticket)
                //创建人是登录的用户
                this.form.createBy=localStorage.getItem("userName")
                console.log(this.form.createBy)
                let b  =false ;
                for(let i=0;i<this.ticket.length;i++) {
                    if ( this.form.toolId == this.ticket[i].toolId && this.form.toolId !=this.reData.toolId) {
                        this.$message({
                            message: '仪器组号不能重复',
                            type: 'warning'
                        });
                        b=true;
                        break;
                    }
                    if (this.form.toolName === this.ticket[i].toolName  && this.form.toolName !==this.reData.toolName) {
                        this.$message( {
                            message: '仪器组名不能重复',
                            type: 'warning'
                        } );
                        b=true
                        break;
                    }
                }
                if(b){
                    return false;
                }

                if (this.form.toolName == null || this.form.toolName == '' || this.form.toolName == undefined) {
                    this.$message( {
                        message: '仪器组名不为空',
                        type: 'warning'
                    } );
                    return false;
                }
                console.log( "-----uu" )

                if (this.form.toolId == null || this.form.toolId == '' || this.form.toolId == undefined) {
                    this.$message( {
                        message: '仪器组号不为空',
                        type: 'warning'
                    } );
                    return false;
                }
                console.log( "-----kk" )

                // eslint-disable-next-line no-unused-vars
                request.post( '/tool/add', this.form ).then( res => {
                    console.log( this.form );
                    this.$message( {
                        message: '添加成功',
                        type: 'success'
                    } );
                    this.load()
                    this.formVisible=false //关闭弹窗

                } )
            },
            refresh(){
                this.currentPage=1;
                this.load()
                this.$message({
                    message: '刷新成功',
                    type: 'success'
                });
            },

            //v为用户的输入 nameCheck作用添加名字不重复
            //这里是this.ticket是因为在this.load中ticket接收了所有的数据
            nameCheck1 (v) {
                try {
                    this.ticket.forEach(item => {
                        if (item.toolName == v)
                            throw new Error("name-check-error");
                    })
                    return true
                } catch (e) {
                    if (e.message == "name-check-error") {
                        this.$message({
                            message:'仪器组名已存在',
                            type: 'warning'
                        })
                        return false
                    }
                }
            },
            nameCheck2 (v) {
                try {
                    this.ticket.forEach(item => {
                        if (item.toolId == v)
                            throw new Error("name-check-error");
                    })
                    return true
                } catch (e) {
                    if (e.message == "name-check-error") {
                        this.$message({
                            message:'仪器组号已存在',
                            type: 'warning'
                        })
                        return false
                    }
                }
            }
        }

    }
</script>
<style>

</style>
